import React from 'react';
//import Scss
import './assets/scss/themes.scss';
//imoprt Route
import Route from './Routes';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <React.Fragment>
      <Route />
      <ToastContainer
        position="top-right"
        autoClose={2000}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
    />
    </React.Fragment>
  );
}

export default App;